import { HttpClient, HttpContext } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { HTTP_CONTEXT_TOKEN_NO_TOKEN } from "src/app/core/http-context-tokens";

export type BabelSet = Record<string, string>;

@Injectable()
export class BabelBackend {
  private readonly http = inject(HttpClient);

  load(lang: string): Observable<BabelSet> {
    return this.http.get<BabelSet>(
      `${environment.snoots.api.babel}/locales/${lang}/translations.json`,
      {
        context: new HttpContext().set(HTTP_CONTEXT_TOKEN_NO_TOKEN, true)
      }
    );
  }

  loadDiagnostic(lang: string): Observable<BabelSet> {
    return this.http.get<BabelSet>(
      `${environment.snoots.api.babel}/locales/${lang}/diagnostic.json`,
      {
        context: new HttpContext().set(HTTP_CONTEXT_TOKEN_NO_TOKEN, true)
      }
    );
  }
}
